(function () {
	'use strict';

	// ─── Nav Menu burger ────────────────────────────────────────────────────────
	// includes/elementor.php prints .arelis-burger before Elementor's (hidden)
	// .elementor-menu-toggle. The button forwards clicks to the toggle, so Pro's
	// handler keeps doing the work (open state, stretch, tabindex, closing on a
	// link click), and mirrors the toggle's state back into aria-expanded and
	// .is-active, which drives the bars → X morph in _header.scss.

	function initBurger(widget) {
		var button = widget.querySelector('.arelis-burger');
		var toggle = widget.querySelector('.elementor-menu-toggle');
		var dropdown = widget.querySelector('.elementor-nav-menu--dropdown.elementor-nav-menu__container');
		if (!button || !toggle || button.dataset.ready) {
			return;
		}
		button.dataset.ready = '1';

		if (dropdown) {
			dropdown.id = dropdown.id || 'arelis-menu-' + widget.getAttribute('data-id');
			button.setAttribute('aria-controls', dropdown.id);
		}

		function isOpen() {
			return toggle.classList.contains('elementor-active');
		}

		function sync() {
			var open = isOpen();
			button.setAttribute('aria-expanded', String(open));
			button.classList.toggle('is-active', open);
		}

		button.addEventListener('click', function () {
			toggle.click();
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && isOpen()) {
				toggle.click();
				button.focus();
			}
		});

		new MutationObserver(sync).observe(toggle, { attributes: true, attributeFilter: ['class'] });
		sync();
	}

	function initAll(scope) {
		Array.prototype.forEach.call((scope || document).querySelectorAll('.elementor-widget-nav-menu'), initBurger);
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAll();
	});

	// Elementor editor: widgets re-render, so initialise again on each render.
	window.addEventListener('elementor/frontend/init', function () {
		window.elementorFrontend.hooks.addAction('frontend/element_ready/nav-menu.default', function ($scope) {
			initAll($scope[0].parentNode);
		});
	});

})();
